import React from 'react';

import { Shield2 } from '@crehana/icons';

import { useTranslation } from '@crehana/i18n';
import { grayLight } from '@crehana/ui/dist/styles/colors';

const SecurePayment: React.FC<{ className?: string; isVariant?: boolean }> = ({
  className,
  isVariant,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`flex items-center rounded-5 ${className}`}>
      <Shield2
        size={47}
        circleColor={grayLight}
        ignoreColor
        className={`fill-current ${
          isVariant ? ' text-primary-main' : 'text-primary-dark'
        }`}
      />
      <div className="ml-8">
        <p
          className={`font-link ${
            isVariant ? 'text-primary-main' : 'text-primary-dark'
          }`}
        >
          {t('SAFE_LABEL')}
        </p>
      </div>
    </div>
  );
};

export default SecurePayment;
